import { InjectionToken } from '@angular/core';

// eslint-disable-next-line no-untranslated-string/no-untranslated-string
export const Is12hFormat = new InjectionToken<() => boolean>('Is12hFormat');
